export const DEFAULT_VALUES = {
    NONE: 'None',
    DATA: 'Data'
} as const;

export const SNAPSHOT_TYPES = {
    SINGLE_BRAND: 'Single Brand'
} as const;

export const CHART_TYPES = {
    COLUMN: 'column',
    BAR: 'bar'
} as const;
